export const SAVE_SELECTED_STOCKS = 'SAVE_SELECTED_STOCKS';
export const RESET_SELECTED_STOCKS = 'RESET_SELECTED_STOCKS';